import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { PrivateRoute } from "./privateRoutes";
import { AdminOnly } from '../components/AdminOnly';
import { Login } from '../pages/Login';
import { Home } from '../pages/Home';
import { Collaborator } from '../pages/Collaborator';
import { Reports } from '../pages/Reports';
import { Growth } from '../pages/Growth';
import { Sales } from '../pages/Sales';

export const Routers = () =>{
  return(
    <Routes>
      <Route path="/" element={<Login/>} />
      <Route path="/dashboard" element={
        <AdminOnly>
          <PrivateRoute/>
        </AdminOnly>
      }>
        <Route element={<Home/>} path="/dashboard"/>
      </Route>
      <Route path="/collaborator" element={
        <AdminOnly>
          <PrivateRoute/>
        </AdminOnly>
      }>
        <Route element={<Collaborator/>} path="/collaborator"/>
      </Route>
      <Route path="/reports" element={
        <AdminOnly>
          <PrivateRoute/>
        </AdminOnly>
      }>
        <Route element={<Reports/>} path="/reports"/>
      </Route>
      <Route path="/growth" element={
        <AdminOnly>
          <PrivateRoute/>
        </AdminOnly>
      }>
        <Route element={<Growth/>} path="/growth"/>
      </Route>
      <Route path="/sales" element={
        <AdminOnly>
          <PrivateRoute/>
        </AdminOnly>
      }>
        <Route element={<Sales/>} path="/sales"/>
      </Route>
    </Routes>
  )
}